var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from 'react';
import { Route } from 'react-router';
import { Container } from 'typedi';
import { AuthManager } from '../services/auth';
import { AppStateContext } from '../services/context';
import { wechatClient } from '../services/wechat';
import { AuthWechat } from './AuthWechat';
var AuthRoute = /** @class */ (function (_super) {
    __extends(AuthRoute, _super);
    function AuthRoute() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuthRoute.prototype.componentDidMount = function () {
        if (!Container.get(AuthManager).isAuthenticated() && !wechatClient.checkIsWechat()) {
            // TODO path name should be auth-cellphone
            this.props.history.replace({ pathname: '/auth', state: { returnPath: this.props.location.pathname } });
        }
    };
    AuthRoute.prototype.getWechatAuth = function () {
        var _this = this;
        return (React.createElement(AppStateContext.Consumer, null, function (_a) {
            var onLoginSuccess = _a.onLoginSuccess, onLoginError = _a.onLoginError;
            return React.createElement(AuthWechat, __assign({ onSuccess: onLoginSuccess, onError: onLoginError }, _this.props));
        }));
    };
    AuthRoute.prototype.render = function () {
        if (!Container.get(AuthManager).isAuthenticated()) {
            if (wechatClient.checkIsWechat()) {
                return this.getWechatAuth();
            }
            return null;
        }
        return React.createElement(Route, __assign({}, this.props));
    };
    return AuthRoute;
}(Component));
export { AuthRoute };
//# sourceMappingURL=AuthRoute.js.map


//////////////////
// WEBPACK FOOTER
// ../core-h5/build/src/components/AuthRoute.js
// module id = 1121
// module chunks = 0